import { SwitcherButtonStyle } from "../../../../../../src/types/Interface";


export const BLUE_ANGLE_COLORS = [0x21D4FE, 0x0195B8];
export const START_BUTTON_STYLE: SwitcherButtonStyle = {
  x: 0,
  y: 80,
  width: 140,
  height: 36,
  defaultBgColor: BLUE_ANGLE_COLORS[0],
  pressedBgColor: 0xFFFFFF,
  border: false
}